// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1605) return "static/chunks/1605.1fc2e5be04570671.js";
	if (chunkId === 4973) return "static/chunks/c9c1c5d6.7a46178b6bf8608e.js";
	if (chunkId === 9160) return "static/chunks/9160.6dbf0b5de78f3ee0.js";
	if (chunkId === 9613) return "static/chunks/9613.6c068351e46e7714.js";
	if (chunkId === 227) return "static/chunks/227.11347e3189663898.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"11":"3e6aaf951d048b75","1843":"4d9a3a11151fa254","2425":"e9da0137300fac45","3781":"e06623e23a9e56fc","4208":"356da1d05986edb6","4693":"ea711eb2f4190025","7043":"293667caa7ddbfbc","8260":"caa3b6de56d8e722","9056":"189fd93f867c926d","9086":"8bd26486afa425ac"}[chunkId] + ".js";
};